export function useEnvironment() {
  const environment = window.env.ENVIRONMENT_NAME

  return { environment }
}
